import React from 'react';
import { Icon } from 'antd';

const ChatbotSvg = () => {
  return (
    <svg width="231" height="255" viewBox="0 0 231 255" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_22_1771)">
        <g filter="url(#filter0_ddd_22_1771)">
          <path
            d="M230.68 115.34C230.68 166.69 197.12 210.2 150.74 225.13C139.59 228.74 127.69 230.68 115.34 230.68C102.99 230.68 91.09 228.73 79.94 225.13C78.95 224.82 77.96 224.49 76.98 224.14C59.13 237.7 30.77 256.11 10.34 254.2C35.34 216.2 22.25 183.44 22.25 183.43C8.26 164.35 0 140.81 0 115.34C0 51.64 51.64 0 115.34 0C179.04 0 230.68 51.64 230.68 115.34Z"
            fill="#13C26B"
          />
          <path
            d="M115.34 44.45C71.1401 44.45 35.3101 53.25 35.3101 116.39C35.3101 141.22 55.4401 161.35 80.2701 161.35H150.41C175.24 161.35 195.37 141.22 195.37 116.39C195.37 53.25 159.54 44.45 115.34 44.45Z"
            fill="white"
          />
          <path
            d="M115.34 44.45C71.1401 44.45 35.3101 53.25 35.3101 116.39C35.3101 141.22 55.4401 161.35 80.2701 161.35H150.41C175.24 161.35 195.37 141.22 195.37 116.39C195.37 53.25 159.54 44.45 115.34 44.45Z"
            fill="white"
          />
          <path
            d="M159.6 130.95H71.0801C44.5301 130.95 41.5801 116.5 36.6701 96.99C35.7901 102.81 35.3101 109.23 35.3101 116.39C35.3101 141.22 55.4401 161.35 80.2701 161.35H150.41C175.24 161.35 195.37 141.22 195.37 116.39C195.37 109.24 194.89 102.82 194.01 96.99C189.1 116.5 186.15 130.95 159.6 130.95Z"
            fill="#EEEFF1"
          />
          <path
            d="M153.47 123.48H78.6903C57.9003 123.48 50.0503 115.36 50.0503 103.13C50.0503 90.9 62.1003 79.18 84.9103 79.18H147.25C170.06 79.18 182.11 90.9 182.11 103.13C182.11 115.36 174.25 123.48 153.46 123.48H153.47Z"
            fill="black"
          />
          <path
            d="M115.34 104.98C140.15 104.98 163.11 103.19 181.84 100.16C180.05 89.07 168.21 79.18 147.25 79.18H84.91C63.81 79.18 51.94 89.2 50.27 100.39C68.74 103.28 91.16 104.98 115.34 104.98Z"
            fill="#262626"
          />
          <path
            d="M88.1801 86.89C80.2901 86.89 73.8701 93.31 73.8701 101.21C73.8701 101.9 73.9201 102.58 74.0201 103.24C75.0001 110.17 80.9801 115.52 88.1801 115.52C94.8301 115.52 100.44 110.96 102.04 104.81C102.34 103.66 102.5 102.46 102.5 101.21C102.5 93.31 96.0801 86.89 88.1801 86.89ZM88.1801 111.93C83.0801 111.93 78.7901 108.34 77.7201 103.55C77.5501 102.8 77.4601 102.01 77.4601 101.21C77.4601 95.3 82.2701 90.49 88.1801 90.49C94.0901 90.49 98.9001 95.3 98.9001 101.21C98.9001 102.43 98.7001 103.6 98.3201 104.69C96.8701 108.9 92.8801 111.93 88.1801 111.93Z"
            fill="#00F1FF"
          />
          <path
            d="M95.1899 101.21C95.1899 105.08 92.0499 108.22 88.1799 108.22C84.3099 108.22 81.1699 105.08 81.1699 101.21C81.1699 97.34 84.3099 94.2 88.1799 94.2C92.0499 94.2 95.1899 97.34 95.1899 101.21Z"
            fill="black"
          />
          <path
            d="M88.6603 98.39C88.6603 100.01 87.3503 101.33 85.7203 101.33C84.0903 101.33 82.7803 100.01 82.7803 98.39C82.7803 96.77 84.1003 95.45 85.7203 95.45C87.3403 95.45 88.6603 96.76 88.6603 98.39Z"
            fill="white"
          />
          <path
            d="M142.5 86.89C134.6 86.89 128.18 93.31 128.18 101.21C128.18 102.45 128.34 103.66 128.64 104.8C130.23 110.96 135.84 115.52 142.5 115.52C149.7 115.52 155.68 110.17 156.66 103.24C156.76 102.58 156.81 101.9 156.81 101.21C156.81 93.31 150.39 86.89 142.5 86.89ZM142.5 111.93C137.81 111.93 133.81 108.9 132.36 104.69C131.98 103.6 131.78 102.43 131.78 101.21C131.78 95.3 136.59 90.49 142.5 90.49C148.41 90.49 153.21 95.3 153.21 101.21C153.21 102.01 153.12 102.8 152.95 103.55C151.88 108.34 147.6 111.93 142.5 111.93Z"
            fill="#00F1FF"
          />
          <path
            d="M135.49 101.21C135.49 105.08 138.63 108.22 142.5 108.22C146.37 108.22 149.51 105.08 149.51 101.21C149.51 97.34 146.37 94.2 142.5 94.2C138.63 94.2 135.49 97.34 135.49 101.21Z"
            fill="black"
          />
          <path
            d="M142.02 98.39C142.02 100.01 143.33 101.33 144.96 101.33C146.59 101.33 147.9 100.01 147.9 98.39C147.9 96.77 146.59 95.45 144.96 95.45C143.33 95.45 142.02 96.76 142.02 98.39Z"
            fill="white"
          />
          <g style={{ 'mix-blend-mode': 'multiply' }}>
            <path
              d="M115.34 148.69C106.48 148.69 98.4501 145.41 94.3801 140.13C93.4701 138.95 93.6901 137.26 94.8701 136.35C96.0501 135.44 97.7401 135.65 98.6501 136.84C101.68 140.76 108.22 143.3 115.34 143.3C122.46 143.3 129 140.77 132.02 136.84C132.93 135.66 134.62 135.44 135.81 136.35C136.99 137.26 137.21 138.95 136.3 140.13C132.23 145.41 124.2 148.69 115.34 148.69Z"
              fill="black"
            />
          </g>
          <path
            d="M158.19 195.93C158.02 197.76 157.69 199.64 157.19 201.55L152.36 220.06C151.91 221.78 151.37 223.48 150.74 225.13C139.59 228.74 127.69 230.68 115.34 230.68C102.99 230.68 91.0902 228.73 79.9402 225.13C79.3102 223.48 78.7702 221.78 78.3202 220.06L73.4901 201.55C70.3901 189.66 73.8102 179.17 81.5702 172.91C81.8702 172.67 82.1701 172.43 82.4901 172.2C82.8001 171.97 83.1202 171.74 83.4402 171.53C83.7402 171.33 84.0401 171.13 84.3501 170.94C84.8001 170.68 85.2501 170.42 85.7101 170.17C85.9802 170.03 86.2501 169.89 86.5301 169.75C87.6101 169.22 88.7502 168.76 89.9302 168.37C90.3202 168.24 90.7301 168.11 91.1301 168C91.4901 167.89 91.8602 167.79 92.2302 167.71C92.3102 167.68 92.3902 167.66 92.4702 167.65C92.8002 167.56 93.1301 167.49 93.4601 167.43C93.5802 167.4 93.7101 167.37 93.8401 167.35C94.1301 167.29 94.4302 167.24 94.7302 167.19C94.8902 167.16 95.0602 167.14 95.2302 167.12C95.5302 167.07 95.8402 167.02 96.1502 166.99C96.2602 166.97 96.3801 166.96 96.5002 166.96C96.8602 166.91 97.2201 166.87 97.5901 166.85C97.6101 166.84 97.6302 166.84 97.6502 166.85C98.0902 166.81 98.5302 166.78 98.9802 166.77C99.4502 166.75 99.9202 166.74 100.39 166.74H130.29C130.76 166.74 131.23 166.75 131.7 166.77C132.15 166.78 132.59 166.81 133.03 166.85C133.05 166.84 133.07 166.84 133.09 166.85C133.46 166.87 133.82 166.91 134.18 166.96C134.3 166.96 134.42 166.97 134.53 166.99C134.84 167.02 135.15 167.07 135.45 167.12C135.62 167.14 135.79 167.16 135.95 167.19C136.25 167.24 136.55 167.29 136.84 167.35C136.97 167.37 137.1 167.4 137.22 167.43C137.55 167.49 137.88 167.56 138.21 167.65C138.29 167.66 138.37 167.68 138.45 167.71C138.82 167.79 139.19 167.89 139.55 168C139.95 168.11 140.36 168.24 140.75 168.37C141.93 168.76 143.07 169.22 144.15 169.75C144.43 169.89 144.7 170.03 144.97 170.17C145.43 170.42 145.88 170.68 146.33 170.94C146.64 171.13 146.94 171.33 147.24 171.53C147.56 171.74 147.88 171.97 148.19 172.2C148.51 172.43 148.81 172.67 149.11 172.91C152.23 175.41 154.65 178.62 156.22 182.33C157.93 186.35 158.65 190.97 158.19 195.93Z"
            fill="#EEEFF1"
          />
          <path
            d="M115.34 56.27C134.85 56.27 152.78 55.32 167.02 53.74C153.07 46.21 135.05 44.44 115.34 44.44C95.6302 44.44 77.6102 46.21 63.6602 53.74C77.8902 55.32 95.8302 56.27 115.34 56.27Z"
            fill="#EEEFF1"
          />
          <path
            d="M134.16 45.73C134.16 48.41 131.99 50.58 129.31 50.58H101.37C98.69 50.58 96.52 48.41 96.52 45.73C96.52 43.05 98.69 40.88 101.37 40.88H129.31C131.99 40.88 134.16 43.05 134.16 45.73Z"
            fill="#D1D2D4"
          />
          <path d="M117.13 18.28H113.54V40.88H117.13V18.28Z" fill="#D1D2D4" />
          <path
            d="M124.72 18.28C124.72 23.46 120.52 27.67 115.34 27.67C110.16 27.67 105.95 23.46 105.95 18.28C105.95 13.1 110.15 8.89001 115.34 8.89001C120.53 8.89001 124.72 13.09 124.72 18.28Z"
            fill="white"
          />
          <path
            d="M115.34 24.11C119.91 24.11 123.71 20.84 124.55 16.5C124.66 17.08 124.73 17.67 124.73 18.28C124.73 23.46 120.53 27.67 115.35 27.67C110.17 27.67 105.96 23.46 105.96 18.28C105.96 17.67 106.03 17.08 106.14 16.5C106.97 20.83 110.77 24.11 115.35 24.11H115.34Z"
            fill="#EEEFF1"
          />
          <path
            d="M101.37 43.29H129.31C131.57 43.29 133.46 44.85 133.99 46.94C134.09 46.55 134.16 46.16 134.16 45.74C134.16 43.06 131.99 40.89 129.31 40.89H101.37C98.69 40.89 96.52 43.06 96.52 45.74C96.52 46.16 96.59 46.56 96.69 46.94C97.23 44.85 99.11 43.29 101.37 43.29Z"
            fill="#EEEFF1"
          />
          <path
            d="M158.54 195.94C155.65 195.94 152.95 194.14 151.93 191.26C150.66 187.63 152.55 183.65 156.17 182.36C156.49 182.24 168.8 177.43 181.21 160.23C183.47 157.1 187.84 156.39 190.98 158.65C194.11 160.91 194.82 165.29 192.56 168.42C177.28 189.61 161.52 195.32 160.85 195.55C160.08 195.82 159.3 195.95 158.53 195.95L158.54 195.94Z"
            fill="white"
          />
          <path
            d="M81.5698 172.91C89.4898 175.18 101.67 176.64 115.34 176.64C129.01 176.64 141.2 175.18 149.11 172.91C144.32 169.03 137.88 166.75 130.29 166.75H100.39C92.7998 166.75 86.3598 169.03 81.5698 172.91Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ddd_22_1771"
          x="-36"
          y="-27"
          width="302.68"
          height="326.337"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_22_1771" />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_22_1771" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_22_1771" result="effect2_dropShadow_22_1771" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="8" operator="dilate" in="SourceAlpha" result="effect3_dropShadow_22_1771" />
          <feOffset dy="9" />
          <feGaussianBlur stdDeviation="14" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_22_1771" result="effect3_dropShadow_22_1771" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_22_1771" result="shape" />
        </filter>
        <clipPath id="clip0_22_1771">
          <rect width="230.68" height="254.34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ChatbotIcon = props => <Icon component={ChatbotSvg} {...props} />;

export default ChatbotIcon;
